import { shortString } from "common/helpers/string"

export const getProposalIdLabel = (id: string): string => {
  const idLabel = id.length > 20 ? shortString(id) : id.toString()

  return idLabel
}

